import { render, staticRenderFns } from "./bottom-loader.vue?vue&type=template&id=0d1f8828&scoped=true&"
import script from "./bottom-loader.vue?vue&type=script&lang=js&"
export * from "./bottom-loader.vue?vue&type=script&lang=js&"
import style0 from "./bottom-loader.vue?vue&type=style&index=0&id=0d1f8828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1f8828",
  null
  
)

export default component.exports